import { z } from "zod";

import { multiSelectDefaultValuesSchema } from "./general.schema";

import {
  basicValidator,
  numberValidator,
  reactSelectValidator,
} from "@/lib/validators";

export const Vehicle = z.object({
  registrationNumber: basicValidator(
    true,
    "Registration Number is required.",
    2,
    50,
  ),
  grossVehicleMass: numberValidator({
    required: true,
    min: 0.1,
    messages: {
      type: "Gross vehicle mass is required.",
      min: "Gross vehicle mass cannot be empty",
    },
  }),
  tareWeight: numberValidator({
    required: true,
    min: 0.1,
    messages: {
      type: "Tare weight is required.",
      min: "Tare weight cannot be empty",
    },
  }),
  usedByALD: z.boolean(),
  customers: reactSelectValidator("Select at least one customer").superRefine(
    (data, ctx) => {
      if (!data || data.length < 1) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Select at least one customer",
        });
      }
    },
  ),
  customersDefaultValues: multiSelectDefaultValuesSchema,
});

export type TVehicle = z.infer<typeof Vehicle>;
